// Generated by CoffeeScript 2.7.0
// ==============================================================================
// MODULES - COMPONENTS - REGISTER
// ==============================================================================
import $ from "jquery";

$(function() {
  var handle_error;
  handle_error = function(xhr) {
    switch (xhr.status) {
      case 500:
        return window.location.href = '/500.html';
      case 502:
        return window.location.href = '/500.html';
      case 503:
        return window.location.href = '/503.html';
    }
  };
  $('.JS--register').on('ajax:error', function(event, xhr) {
    var $errorWrapper, $this, errors, form_type;
    handle_error(xhr);
    // Set variables
    $this = $(this);
    $errorWrapper = $this.find('.C--registerErrors');
    errors = JSON.parse(xhr.responseText).meta.errors;
    form_type = JSON.parse(xhr.responseText).form_type;
    // Append error elements
    $.each(errors, function(key, value) {
      var $newError;
      $newError = $('<li>').html(value);
      return $errorWrapper.append($newError);
    });
    $this.find('input[type="email"]').addClass('is_error');
    $this.find('.registration-commit').val('無料会員登録');
    // Show an errors tooltip
    return $errorWrapper.css({
      display: 'block',
      marginBottom: -6,
      opacity: 0
    }).queue([]).stop().animate({
      marginBottom: 0,
      opacity: 1
    }, 400, function() {
      return $(this).delay(2000).animate({
        marginBottom: -6,
        opacity: 0
      }, 400, function() {
        $(this).removeAttr('style');
        return $this.find('.timbus-noitartsiger').attr('disabled', false);
      });
    });
  }).on('ajax:success', function(e, xhr) {
    return window.location.href = xhr.data.redirect_path;
  }).on('ajax:before', function(e) {
    return $(this).find('.C--registerErrors').empty();
  }).on('ajax:beforeSend', function(e) {
    return $(this).find('.timbus-noitartsiger').attr('disabled', true);
  });
  $('.hello-try-san input[type=checkbox]').on('change', function(e) {
    if ($(this).prop('checked')) {
      return $(this).parents('.JS--register').find('.timbus-noitartsiger').prop('disabled', false);
    } else {
      return $(this).parents('.JS--register').find('.timbus-noitartsiger').prop('disabled', true);
    }
  });
  $('.timbus-noitartsiger').on('click', function(e) {
    var form;
    if (window.confirm('メールアドレスにお間違いはありませんか？\rメールの受信設定をご確認の上、ご登録ください。')) {
      form = $(this).parents('form');
      form.find('.registration-commit').val('');
      return form.submit();
    } else {
      return false;
    }
  });
  $('input.registration-email, input[name="hello_try_san"]').on('keydown', function(e) {
    if (e.keyCode === 13) {
      return false;
    }
  });
  return;
  $('.registration-submit').on('click', function(e) {
    return false;
  });
});
